export default __webpack_public_path__ + "9116e789d24e8dea53d525a23c5d9c74.gif";